module.exports = __webpack_public_path__ + "static/media/medford-placeholder.27b42611.webp";